import { Provider } from "@radix-ui/react-toast";

// Components
import { Root } from "./Root";
import { Viewport } from "./Viewport";
import { Content } from "./Content";
import { Title } from "./Title";
import { Description } from "./Description";
import { Link } from "./Link";
import { Close } from "./Close";
import { Icon } from "./Icon";

// Types
import type {
  ToastIconProps,
  ToastCloseProps,
  ToastContentProps,
  ToastTitleProps,
  ToastDescriptionProps,
  ToastLinkProps,
  ToastAnchorLinkProps,
  ToastRouterLinkProps,
  ToastVariant
} from "./Toast.types";

// Create the Toast namespace
const Toast = Object.assign(Root, {
  Provider,
  Root,
  Viewport,
  Content,
  Title,
  Description,
  Link,
  Close,
  Icon
});

// Export the Toast namespace
export { Toast };

// Export components individually
export {
  Provider,
  Root,
  Viewport,
  Content,
  Title,
  Description,
  Link,
  Close,
  Icon
};

// Export types and enums
export type {
  ToastIconProps,
  ToastCloseProps,
  ToastContentProps,
  ToastTitleProps,
  ToastDescriptionProps,
  ToastLinkProps,
  ToastAnchorLinkProps,
  ToastRouterLinkProps
};

export { ToastVariant };

// Default export for internal usage
export default Toast;
